import { Constants } from "@global-mediation/globalmediation-core/Constants";
import { ClientSatisfactionQuestionnaire } from "@global-mediation/globalmediation-core/Server/Schema/Entities/ClientSatisfactionQuestionnaire.Generated";
import { Enquiry } from "@global-mediation/globalmediation-core/Server/Schema/Entities/Enquiry.Generated";
import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { EntityManager } from "@seriously-rad/seriouslyrad-framework-core/EntityManager";
import { JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { RadObject } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerCoreAsync, registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { nameof } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/Extensions";
import { ClientAwareLookupItemAttribute } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/ClientAwareLookupItemAttribute";
import { ChartColorSchemes } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Chart/ColorSchemes";
import { CheckBoxTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBox";
import { CheckBoxListApiMethod } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListApiMethod";
import { CheckBoxListFlags } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListFlags";
import { CheckBoxListYesNo } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListYesNo";
import { ComboBoxApiMethod } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ComboBoxApiMethod";
import { FullPageLoader } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/FullPageLoader";
import { PropertyEditorNew } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorNew";
import { Page } from "@seriously-rad/seriouslyrad-framework-core/Ui/Pages/Page";
import { CheckBoxListAgreeDisagree } from "./Ui/Controls/CheckBoxListAgreeDisagree";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerAppAsync(configuration: Configuration)
{
    RadObject.registerPropertyDefaultOverride(Page, () => ({
        transitionName: "fade",
    }));

    ChartColorSchemes["globalmediation"] = {
        one: ["#8441be", "#cb1d95", "#eb2361", "#eb552d", "#d18300", "#a4a700", "#5fc43b"],
        yesNo: ["#24eb24", "#eb2424"]
    };

    radWindow.entityManager = new EntityManager();
    radWindow.fullPageLoader = new FullPageLoader();

    registerCoreAsync(configuration);

    JNativeStatic.ajaxSetup({
        timeout: null
    });

    PropertyEditorNew.registerEditorControlOverride(propertyInfo =>
    {
        switch (propertyInfo.typeInfo?.name)
        {
            case Enquiry.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(Enquiry, "bestCallTimeframe"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.ENQUIRY_TELEPHONE_CALL_TIMESLOT_LIST }), })
                        case nameof(Enquiry, "decisionLookupItemId"):
                            return new ComboBoxApiMethod({
                                api: "portal",
                                data: { type: "GM Enquiry Decisions" },
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                        case nameof(Enquiry, "ehcpContent"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_EHCP_SECTIONS_IN_DISPUTE_LIST_SUPPORTED }), })
                        case nameof(Enquiry, "initialEnquiryMadeByLookupItemId"):
                            return new ComboBoxApiMethod({
                                api: "portal",
                                data: { type: "GM Case Enquirers" },
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                        case nameof(Enquiry, "parentTitleLookupItemId"):
                            return new ComboBoxApiMethod({
                                api: "portal",
                                data: { type: "GM Person Titles" },
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                        case nameof(Enquiry, "primarySpecialNeedsDiagnosisLookupItemId"):
                            return new ComboBoxApiMethod({
                                api: "portal",
                                data: { type: "GM Special Needs Diagnoses" },
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                        case nameof(Enquiry, "titleLookupItemId"):
                            return new ComboBoxApiMethod({
                                api: "portal",
                                data: { type: "GM Person Titles" },
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                    }

                    break;
                }
            case ClientSatisfactionQuestionnaire.name:
                {
                    const
                        lookupItemAttribute = propertyInfo.getAttribute(ClientAwareLookupItemAttribute);

                    if (lookupItemAttribute && lookupItemAttribute.typeDescription === "CSQ Agree / Disagree Ratings")
                        return new CheckBoxListAgreeDisagree();

                    switch (propertyInfo.name)
                    {
                        case nameof(ClientSatisfactionQuestionnaire, "sourceLookupItemId"):
                            return new CheckBoxListApiMethod({
                                api: "portal",
                                checkBoxType: CheckBoxTypeEnum.radio,
                                data: { type: "CSQ Sources"},
                                listDataSourceValueProperty: "id",
                                listDataSourceDescriptionProperty: "description",
                                method: "lookupitems",
                            });
                        case nameof(ClientSatisfactionQuestionnaire, "canContact"):
                        case nameof(ClientSatisfactionQuestionnaire, "canShareFeedback"):
                        case nameof(ClientSatisfactionQuestionnaire, "canUseNameOrOrganisationsName"):
                            {
                                return new CheckBoxListYesNo();
                            }
                    }

                    break;
                }
        }

        return undefined;
    });

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}